import axios from './base'

// ================= 用户管理（后端 UserService，tb_user，/user*） =================
// 产品规则：后台对用户只读 + 禁用/启用，无新增编辑删除；禁用后无法登录小程序，已发布内容保留
// 手机号后端脱敏返回（前3后4），任何接口不返回明文

// 用户列表（分页；keyword 昵称/手机号、status 1正常 0禁用、date_range 注册时间区间；注册时间倒序）
export function getUserList(params = {}) {
  return axios.request({
    url: `/user`,
    method: 'get',
    params,
  })
}

// 用户详情（列表字段 + auth_status 实名认证状态）
export function getUserDetail(id) {
  return axios.request({
    url: `/user/${id}`,
    method: 'get',
  })
}

// 启用 / 禁用（data: { status: 1 启用 / 0 禁用 }）
export function setUserStatus(id, data = {}) {
  return axios.request({
    url: `/user/${id}/status`,
    method: 'put',
    data,
  })
}

// 修改推荐人（data: { referrer_id: 员工 id }，传 0 表示解除绑定）
// 员工候选来自 GET /system/person-options；企业账号只能选自己公司及下级员工（后端二次校验）
export function setUserReferrer(id, data = {}) {
  return axios.request({
    url: `/user/${id}/referrer`,
    method: 'put',
    data,
  })
}

// ================= 实名认证审核（后端 UserAuthService，tb_user_auth，/user/auth*） =================
// 产品规则：C 端提交姓名+证件照片 → 后台审核 → 通过/驳回（驳回必须填原因）
// 证件号任何接口只返回脱敏值；证件照片只在详情返回；审核结果与用户实名状态双向同步

// 认证申请列表（分页；keyword 昵称/真实姓名/手机号、status 0待审核 1已通过 2已驳回、date_range 提交时间区间）
export function getUserAuthList(params = {}) {
  return axios.request({
    url: `/user/auth`,
    method: 'get',
    params,
  })
}

// 认证申请详情（列表字段 + id_card_front / id_card_back 证件照片）
export function getUserAuthDetail(id) {
  return axios.request({
    url: `/user/auth/${id}`,
    method: 'get',
  })
}

// 通过认证（无请求体；仅待审核可操作，写审核时间并同步用户实名状态）
export function passUserAuth(id) {
  return axios.request({
    url: `/user/auth/${id}/pass`,
    method: 'put',
  })
}

// 驳回认证（data: { reject_reason: '驳回原因，必填' }；仅待审核可操作）
export function rejectUserAuth(id, data = {}) {
  return axios.request({
    url: `/user/auth/${id}/reject`,
    method: 'put',
    data,
  })
}
